import styles from './Section.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import {AbstractConstructor, withLayer} from "../../base/layer/withLayer";

// This reference container provides a base structure, but may not be used / needs to be completed
class NXTSection extends withLayer(CustomComponent as AbstractConstructor<CustomComponent>) {
    readonly DEFAULT_LAYER_STEP = 0;

   constructor() {
      super();
      this.customStyle = styles;
   }

   render() {
      const element = document.createElement('div');
      element.classList.add(`section-content`);
      element.innerHTML = `
           <slot></slot>
      `;
      return element;
   }

}

customElements.define('nxt-section', NXTSection);
